module.exports = __webpack_public_path__ + "files/7c0f1fe2de92db6809ca3bd7dcc7df7b.png";